import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "remove-confirm" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "remove-confirm_title" }, "Удалить оценку времени?", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "remove-confirm_content" }, " Вы сможете заново пригласить сотрудника для выставления оценки ", -1)
const _hoisted_4 = { class: "remove-confirm_footer" }

import {
  PopoverPositionEnum,
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmPopover,
} from "tir-components";
import { AdapterService } from "./adapter-service";
import { computed, ref } from "vue";
import { TrashIcon } from "tir-style-system/icons/outline";
import { CurrentUser } from "tir-pm-user-core";

/**Api сервис */

export default /*#__PURE__*/_defineComponent({
  __name: 'task-time-estimate-remove',
  props: {
  /**Id задачи */
  taskId: { type: Number },
  /**Удаляемый пользователь */
  performerId: { type: Number },
},
  emits: ["onRemove", "open", "close"],
  setup(__props, { emit }) {

const props = __props;

const apiService = new AdapterService();

/**Параметры */

/**События */


/**Компонент поповера */
const $popover = ref<InstanceType<typeof TirPmPopover>>();
/**Загрузка удаления */
const isLoading = ref(false);

/**Текущий пользователь */
const isCurrentUser = computed(() => CurrentUser.Id == props.performerId);

/**Удаление приглашения */
const removeInvite = async () => {
  isLoading.value = true;
  const response = await apiService.removeEstimateInvite(props.taskId, props.performerId);
  if (response.IsSuccess) emit("onRemove", props.performerId);
  isLoading.value = false;
};
/**Удаление оценки */
const removeEstimate = async () => {
  if (CurrentUser.Id == props.performerId) {
    isLoading.value = true;
    const response = await apiService.removeEstimateTime(props.taskId, props.performerId);
    if (response.IsSuccess) emit("onRemove", props.performerId);
    isLoading.value = false;
  }
};
/**Закрытия окна */
const close = () => {
  $popover.value?.close?.();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TirPmPopover), {
    ref_key: "$popover",
    ref: $popover,
    "is-disabled": isCurrentUser.value,
    position: _unref(PopoverPositionEnum).Top,
    onOpen: _cache[0] || (_cache[0] = ($event: any) => (emit('open'))),
    onClose: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(TirPmButton), {
        "is-loading": isLoading.value,
        size: _unref(TirPmButtonSizeEnum).Small,
        variant: _unref(TirPmButtonVariantEnum).LinkState,
        onClick: removeEstimate
      }, {
        leftSlot: _withCtx(() => [
          _createVNode(_unref(TrashIcon))
        ]),
        _: 1
      }, 8, ["is-loading", "size", "variant"])
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(TirPmButton), {
            size: _unref(TirPmButtonSizeEnum).Small,
            variant: _unref(TirPmButtonVariantEnum).PrimaryState,
            onClick: close
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Отмена ")
            ]),
            _: 1
          }, 8, ["size", "variant"]),
          _createVNode(_unref(TirPmButton), {
            size: _unref(TirPmButtonSizeEnum).Small,
            variant: _unref(TirPmButtonVariantEnum).SecondaryState,
            "is-loading": isLoading.value,
            onClick: removeInvite
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Удалить ")
            ]),
            _: 1
          }, 8, ["size", "variant", "is-loading"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["is-disabled", "position"]))
}
}

})